import { takeEvery, put, select, all } from 'redux-saga/effects';
import apiFetcher from '../tools/api-fetcher';
import queryStringify from '../tools/query-stringify';
import { toastr } from 'react-redux-toastr';

import * as types from '../actions/vacancy-close/types';
import * as actions from '../actions/vacancy-close';
import { getVacancySummary, getVacancyApplications } from '../actions/vacancies';
import { getSchoolVacancies } from '../actions/school';

import applicationSubstatuses from '../constants/application-substatuses';

import handleError from '../tools/error-helper';

function* reloadVacancyCloseContextData(schoolId, vacancyId) {
  const vacancyDetails = yield select(state => state.vacancyDetails);
  const schoolVacancies = yield select(state => state.schoolVacancies);
  const vacancyApplications = yield select(state => state.vacancyApplications);

  if (vacancyDetails.get('vacancySummary').get('vacancyId') === vacancyId) {
    yield put(getVacancySummary(schoolId, vacancyId));
   
  }

  if(vacancyApplications.get('results').size) {
    yield put(getVacancyApplications(schoolId, vacancyId, vacancyApplications.get('queryParams')));
  }

  if (schoolVacancies.get('results').toJS().length) {
    yield put(getSchoolVacancies(schoolVacancies.get('queryParams')));
  }
}

function* getClosingVacancyApplications(loadingAction, setDataAction, queryParams, schoolId, vacancyId) {
  yield put(loadingAction(true)); 
  try {
    const { data } = yield apiFetcher
                          .auth()
                          .get(`/schools/${schoolId}/vacancies/${vacancyId}/applications?${queryStringify(queryParams)}`);
    
    yield put(setDataAction(data));
  }
  catch(exception) {
    handleError(exception);
  }
  yield put(loadingAction(false));
}

function* getActiveApplicationsCount({ schoolId, vacancyId }) {
  const queryParams = {
    pageSize: 0,
    pageNumber: 1,
    justActive: true
  };
  yield getClosingVacancyApplications(
    actions.setActiveApplicationsCountLoading,
    actions.setActiveApplicationsCount,
    queryParams,
    schoolId,
    vacancyId
  );
}

function* getHiredApplications({ schoolId, vacancyId }) {
  const queryParams = {
    pageNumber: 1,
    justActive: false,
    substatuses: [applicationSubstatuses.hired]
  };
  yield getClosingVacancyApplications(
    actions.setHiredApplicationsLoading,
    actions.setHiredApplications,
    queryParams,
    schoolId,
    vacancyId
  );
}

function* closeVacancy({ schoolId, vacancyId, notFilledOpeningsCount, filledNotViaApliOpeningsCount }) {
  yield put(actions.setVacancyClosing(true));
  
  const requestBody = {
    vacancyId,
    notFilledOpeningsCount,
    filledNotViaApliOpeningsCount
  };
 
  try {
    yield apiFetcher
          .auth()
          .post(`/schools/${schoolId}/vacancies/closed`, requestBody);

    yield toastr.success('You have successfully closed the vacancy.');
    yield reloadVacancyCloseContextData(schoolId, vacancyId);
  }
  catch(exception) {
    yield handleError(exception);
  }
  yield put(actions.setVacancyClosing(false));
}

export default function* vacancyCloseSaga() {
  yield all([
    takeEvery(types.VACANCY_CLOSE_GET_ACTIVE_APPLICATIONS_COUNT, getActiveApplicationsCount),
    takeEvery(types.VACANCY_CLOSE_GET_HIRED_APPLICATIONS, getHiredApplications),
    takeEvery(types.VACANCY_CLOSE_RUN, closeVacancy)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/vacancy-close.js